import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { SearchOutlined } from "@mui/icons-material";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { uniqBy } from "lodash";
import { DownOutlined, FilterOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Form,
  Select,
  Button,
  Checkbox,
  DatePicker,
  Dropdown,
  Input,
  Modal,
  Table,
  message,
  Popconfirm,
  Spin,
  Popover,
} from "antd";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ReactComponent as Trash } from "../../assets/icons/Deleted_Trash.svg";
import PerformanceContract from "./PerformanceContract";
import { useHistory } from "react-router-dom";
import { CALL_API } from "common/API";
import {
  getLoadNewDataList,
  getLocations,
  getSupervisorList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import moment from "moment";
import trashfull from "../../assets/Trash_Full.png";
import { connect, useDispatch, useSelector } from "react-redux";
import { dateInDetail } from "utils/Date";
import { STATUS_CODE } from "common/Constants";
import { setLoadNewDataList, setMyTeamPerformanceList } from "redux/actions";
import { ButtonFilled } from "reusableComponent/UIButtons";
import CreateEditPerformance from "./CreateEditPerformance";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import isBetween from "dayjs/plugin/isBetween";
import { ReactComponent as ChartBarIcon } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (4).svg";
import { ReactComponent as ChartBarIcon2 } from "../../../src/assets/icons/chart-bar-vertical-01-svgrepo-com 1 (2).svg";
import { ReactComponent as FolderIcon } from "../../assets/icons/FolderIcon.svg";
import PerformanceMatrix from "./Viewperformance/PerformanceMatrix";
import { bindActionCreators } from "redux";
import Consolidated from "./Consolidated";

dayjs.extend(isBetween);
dayjs.extend(advancedFormat);

const { RangePicker } = DatePicker;
const StyledRangePicker = styled(RangePicker)`
  width: 240px !important;
  border-radius: 24px !important;
  margin-left: 10px;
`;
const Styleddiv = styled.div`
  .search-type-date {
    display: flex;
    gap: 24px;
  }
  .searchbar {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .type-dropdown {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .date-picker {
    width: 176px;
    height: 34px;
    border-radius: 24px;
  }
  .ant-picker-input {
    display: flex;
    align-items: center;
  }

  .ant-picker-suffix {
    order: -1; /* This moves the icon to the front */
    margin-right: 8px; /* Optional: adjust the space between the icon and the placeholder */
  }
  .ant-table-thead > tr > th {
    font-weight: 500;
    font-size: 16px;
  }
  .ant-table-tbody > tr > td {
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }

  .normal-column {
    min-width: 300px;
    white-space: normal;
  }

  .action-icons {
    display: none;
    position: absolute;
  }

  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 12px;
    cursor: pointer;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #52c41a !important; /* Green */
    border-color: #52c41a !important;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: #52c41a !important;
  }

  .ant-checkbox-checked::after {
    border: none !important;
  }

  .ant-checkbox-inner {
    width: 16px;
    height: 16px;
  }
  .hovered-row {
    width: 100px;
    display: flex;
    gap: 1rem;
    opacity: 1;
  }
  .row-table {
    width: 100px;
    opacity: 0;
  }

  .table_action_icon {
    background-color: #c2fae5;
    color: black;
    cursor: pointer;
  }
  .custom-row {
    height: 50px; /* Adjust row height */
  }

  .custom-row td {
    padding: 10px; /* Adjust cell padding */
  }
  .custom-select .ant-select-selection-placeholder {
    color: black !important;
  }

  .custom-select .ant-select-selector {
    border-radius: 24px !important;
    color: black !important;
    width: 250px !important; /* Optional, if you want a fixed width */
  }
`;
const StyledModal = styled(Modal)`
  .delete-modal-text {
    font-weight: 400;
    font-size: 18px;
    color: #636980;
  }
  .two-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 16px;
  }

  .no-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #1f243b;
    color: #1f243b;
    font-weight: 400;
    font-size: 16px;
  }
  .yes-modal-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background: #c2fae5;
    border: 1px solid #c2fae5;
    font-weight: 400;
    font-size: 16px;
  }
  .tick-deleted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .deleted-text {
    font-weight: 400;
    font-size: 18px;
  }
`;

const CustomModalContent = styled.div`
  content-align: center;
  height: 50px;
  border-radius: 8px !important;
  background-color: white;
  text-align: center;
`;

const MyTeamPerformance = ({
  editPerformanceData,
  userInfo,
  setIsAddEdit,
  isAddEdit,
  setSelectedUserRecord,
  selectedItem,
  setBreadCrum,
  setLoadNewData,
  loadNewDataList,
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const [performanceContractList, setPerformanceContractList] = useState([]);
  const [form] = Form.useForm();
  const [hoveredRow, setHoveredRow] = useState();
  const history = useHistory();
  const userDataList = useSelector((state) => getUserList(state)) || [];
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);
  const [isDeleteModalLoading, setIsDeleteModalLoading] = useState(false);
  const [chartModalOpen, setChartModalOpen] = useState(false);
  const [chartData, setChartData] = useState({});
  const [chartLoading, setChartLoading] = useState(false);
  const [newDataLoading, setNewDataLoading] = useState(false);
  const [isConsolidate, setIsConsolidate] = useState(false);

  const getPerformanceContractData = async () => {
    setLoading(true);
    const { code, performanceContractList } = await CALL_API(
      `appraisal/appraisermyteam?createdby=${userInfo?.userid}`,
      "get"
    );
    if (code === STATUS_CODE?.SUCCESS) {
      setPerformanceContractList(performanceContractList);
      setLoading(false);
    }
  };

  const transformRollover = (data) => {
    return data?.map((item, index) => {
      return {
        ...item,
        previousappraisalperiod: item?.targetobjectives,
        expectedoutcome: item?.expectedoutcomes,
        TargetDate: dayjs(item?.targetdate, "DD-MM-YYYY").format("YYYY-MM-DD"),
        Weightage: item?.weightage,
      };
    });
  };

  useEffect(() => {
    getPerformanceContractData();
  }, []);

  const finduser = userDataList?.find(
    (item) => item?.userid === userInfo?.userid
  );

  const findData = useMemo(() => {
    if (!userDataList) return [];

    const reduceList = userDataList.reduce((acc, item) => {
      const filteredAppraisals = item.appraisalInformation?.filter(
        (data) =>
          data?.appraiser === finduser?.userid &&
          data?.appraisal === "Yes" &&
          item?.statusid === "1"
      );

      const matchedContract = performanceContractList?.filter(
        (val) =>
          val?.apraiseemailid === item?.userid &&
          val?.roletype === filteredAppraisals?.[0]?.roletype &&
          (item?.performanceid !== "" || item?.performanceid !== null)
      );

      const hasValidAppraisals =
        filteredAppraisals && filteredAppraisals.length > 0;

      if (matchedContract?.length) {
        matchedContract?.map((match) =>
          acc.push({
            ...item,
            attendedon: match?.attendedon || "",
            averagesoftscore: match?.averagesoftscore || "",
            averagetechnicalscore: match?.averagetechnicalscore || "",
            dateofbirth: dayjs(item?.dateofbirth).format("DD-MM-YYYY"),
            appraisalInformation: filteredAppraisals,
            rolloverresponsibility: match?.rolloverresponsibility || [],
            softskills: match?.softskills || [],
            startegicobjectives: match?.startegicobjectives || [],
            upcomingappraisalperiod: match?.upcomingappraisalperiod || [],
            period: match?.period || "",
            createdat: match?.createdat || "",
            updatedat: match?.updatedat || "",
            contractstatus: match?.contractstatus || "",
            attendstartdate: match?.attendstartdate
              ? dayjs(match?.attendstartdate)
              : "",
            attendenddate: match?.attendenddate
              ? dayjs(match?.attendenddate)
              : "",
            apraisercreatedat: match?.apraisercreatedat || "",
            apraisercreatedby: match?.apraisercreatedby || "",
            apraiserupdatedat: match?.apraiserupdatedat || "",
            apraiserupdatedby: match?.apraiserupdatedby || "",
            accepteddeclinedon: match?.accepteddeclinedon || "",
            contractid: match?.contractid,
            performanceid: match?.performanceid || 0,
            existingrollover: transformRollover(match?.existingrollover) || [],
          })
        );
      } else if (hasValidAppraisals) {
        acc.push({
          ...item,
          dateofbirth: dayjs(item?.dateofbirth).format("DD-MM-YYYY"),
          appraisalInformation: filteredAppraisals,
          rolloverresponsibility: matchedContract?.rolloverresponsibility || [],
          softskills: matchedContract?.softskills || [],
          startegicobjectives: matchedContract?.startegicobjectives || [],
          upcomingappraisalperiod:
            matchedContract?.upcomingappraisalperiod || [],
          period: matchedContract?.period || "",
          createdat: matchedContract?.createdat || "",
          updatedat: matchedContract?.updatedat || "",
          contractstatus: matchedContract?.contractstatus || "",
          attendstartdate: matchedContract?.attendstartdate
            ? dayjs(matchedContract?.attendstartdate)
            : "",
          attendenddate: matchedContract?.attendenddate
            ? dayjs(matchedContract?.attendenddate)
            : "",
          apraisercreatedat: matchedContract?.apraisercreatedat || "",
          apraisercreatedby: matchedContract?.apraisercreatedby || "",
          apraiserupdatedat: matchedContract?.apraiserupdatedat || "",
          apraiserupdatedby: matchedContract?.apraiserupdatedby || "",
          accepteddeclinedon: matchedContract?.accepteddeclinedon || "",
          contractid: matchedContract?.contractid,
          performanceid: matchedContract?.performanceid || 0,
          averagesoftscore: "",
          averagetechnicalscore: "",
          attendedon: "",
          existingrollover: [],
        });
      }

      return acc;
    }, []);
    return [...loadNewDataList, ...reduceList];
  }, [
    userDataList,
    finduser?.userid,
    performanceContractList,
    loadNewDataList,
  ]);
  const getLoadNewList = async () => {
    setNewDataLoading(true);
    const { code, performanceContractStatusList } = await CALL_API(
      `appraisal/performancestatus`,
      "get"
    );
    if (code === STATUS_CODE?.SUCCESS) {
      const updatedData = findData.reduce((acc, item) => {
        const finduser = userDataList?.find(
          (val) => val?.userid === item?.userid
        );
        const filteredAppraisals = finduser.appraisalInformation?.filter(
          (data) => data?.appraisal === "Yes" && item?.statusid === "1"
        );

        const appraiserid = filteredAppraisals?.map((user) => user?.appraiser);

        const matchedContract = performanceContractStatusList?.filter(
          (val) =>
            val?.apraiseemailid === item?.userid &&
            val?.performanceid === item?.performanceid &&
            val?.contractstatus === "reviewed" &&
            appraiserid?.includes(val?.apraisercreatedby)
        );

        let max = 0;
        if (matchedContract && matchedContract.length > 0) {
          max = matchedContract.reduce((prev, curr) =>
            curr.performanceid > prev.performanceid ? curr : prev
          );
        }

        const maxContract = matchedContract?.filter(
          (val) => item?.performanceid === max.performanceid
        );

        const hasalreadyexist = findData?.filter(
          (user) =>
            user?.userid === item?.userid &&
            item?.performanceid === max.performanceid
        );

        // const hasValidAppraisals =
        //   filteredAppraisals && filteredAppraisals.length > 0;

        if (
          maxContract?.length === filteredAppraisals?.length &&
          hasalreadyexist?.length === max?.performanceid
        ) {
          acc.push({
            ...item,
            averagesoftscore: "",
            averagetechnicalscore: "",
            attendedon: "",
            rolloverresponsibility: item?.existingrollover,
            softskills: [],
            startegicobjectives: [],
            upcomingappraisalperiod: [],
            period: "",
            createdat: "",
            updatedat: "",
            contractstatus: "",
            attendstartdate: "",
            attendenddate: "",
            apraisercreatedat: "",
            apraisercreatedby: "",
            apraiserupdatedat: "",
            apraiserupdatedby: "",
            accepteddeclinedon: "",
            contractid: "",
            appraisalInformation: item.appraisalInformation?.filter(
              (data) =>
                data?.appraiser === userInfo?.userid &&
                data?.appraisal === "Yes" &&
                item?.statusid === "1"
            ),
          });
        }

        return acc;
      }, []);
      if (updatedData?.length > 0) {
        setLoadNewData(updatedData);
      }

      setNewDataLoading(false);
    }
  };

  const filterPerformanceData = useMemo(() => {
    return findData?.filter((item) => {
      const start = dayjs(item?.attendstartdate, "YYYY-MM-DD").startOf("day");
      const end = dayjs(item?.attendenddate, "YYYY-MM-DD").endOf("day");
      const today = dayjs().startOf("day");

      return (
        item?.contractstatus !== "created" &&
        item?.contractstatus !== "resend" &&
        item?.contractstatus !== "updated" &&
        item?.contractstatus !== "declined" &&
        (item?.contractstatus === "accepted" ||
          item?.contractstatus === "attended" ||
          item?.contractstatus === "draft" ||
          item?.contractstatus === "reviewed")
      );
    });
  }, [findData]);

  const handleRowClick = (record) => {
    if (
      selectedItem === "performance-management" &&
      record?.contractstatus === "accepted"
    ) {
      history.push(`/awaitngresponse/${record?.contractid}`, {
        appraisalRecord: record,
      });
    } else if (
      selectedItem === "performance-management" &&
      record?.contractstatus === "reviewed"
    ) {
      history.push({
        pathname: `/viewmytabledata/${record?.contractid}`,
        state: {
          appraisalRecord: record,
          isEdit: false,
          data: record,
          roletype: record.roletype,
        },
      });
    } else if (
      (selectedItem === "performance-contract" &&
        (record?.contractstatus === "created" ||
          record?.contractstatus === "resend" ||
          record?.contractstatus === "updated" ||
          record?.contractstatus === "attended")) ||
      record?.contractstatus === "declined" ||
      record?.contractstatus === "accepted" ||
      record?.contractstatus === "accepted" ||
      record?.contractstatus === "reviewed"
    ) {
      history.push(`/viewcontract/${record?.contractid}`, {
        appraisalRecord: record,
      });
    }
  };

  const deleteContract = async (record) => {
    try {
      setIsDeleteModalLoading(true);
      const { code } = await CALL_API(
        `appraisal/${record?.contractid}`,
        "delete"
      );
      if (code === STATUS_CODE.SUCCESS) {
        message.success("Contract deleted successfully");
        getPerformanceContractData();
        setIsDeleteModalOpen(false); // ✅ Close only after success
      }
    } catch (err) {
      message.error("Failed to delete contract");
    } finally {
      setIsDeleteModalLoading(false); // ✅ stop button loading
    }
  };

  useEffect(() => {
    if (editPerformanceData) {
      form.setFieldsValue(editPerformanceData);
    }
  }, [editPerformanceData, form]);

  const getChartData = async (userId, performanceid) => {
    try {
      setChartLoading(true);
      const { performanceContractList, code } = await CALL_API(
        `/appraisal/appraiseemine?userid=${userId}`,
        "get"
      );
      if (code === "SUCCESS") {
        const filterd = performanceContractList?.filter(
          (item) => item?.performanceid === performanceid
        );
        const totalAppraisal = userDataList?.find(
          (val) => val?.userid === userId
        )?.appraisalInformation;
        const activeAppraisal = totalAppraisal?.filter(
          (item) => item?.appraisal === "Yes"
        )?.length;
        const validTechnicalScores = filterd
          .map((item) => Number(item.averagetechnicalscore))
          .filter((score) => !isNaN(score));

        const averageTechnicalScore =
          validTechnicalScores.reduce((sum, score) => sum + score, 0) /
          validTechnicalScores?.length || 0;

        const averageSoftScoreForPrimary =
          filterd?.find((item) => item.roletype === "Primary")
            ?.averagesoftscore || 0;

        if (
          activeAppraisal === filterd?.length &&
          filterd.every((contract) => contract.contractstatus === "reviewed")
        ) {
          setChartData({
            xvalue: averageSoftScoreForPrimary,
            yvalue: averageTechnicalScore,
          });
        } else {
          setChartData({});
        }
        setChartLoading(false);
      } else {
        setChartLoading(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      return [];
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "25%",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "25%",
    },
    {
      title: "Type",
      dataIndex: "appraisalInformation",
      key: "appraisalInformation",
      width: "25%",
      render: (appraisalInformation) => {
        if (!appraisalInformation || appraisalInformation.length === 0) {
          return "-";
        }
        const types = appraisalInformation
          ?.map((info) => info?.roletype)
          ?.join(", ");
        return types || "-";
      },
    },
    {
      title: "Period",
      dataIndex: "period",
      key: "period",
      width: "25%",
      render: (text) => {
        return text ? text : "---";
      },
    },
    {
      title: "Created",
      dataIndex: "createdat",
      key: "createdat",
      width: "25%",
      render: (text) => {
        return text ? dayjs(text, "YYYY-MM-DD").format("Do MMM, YYYY") : "---";
      },
    },
    {
      title: "Attend Appraisal",
      dataIndex: "attendappraisal",
      key: "attendappraisal",
      width: "25%",
      render: (text, record) => {
        const startDate = record?.attendstartdate || null;
        const endDate = record?.attendenddate || null;

        if (startDate && endDate) {
          return `${dayjs(startDate).isValid() ? dayjs(startDate).format("Do MMM, YYYY") : "---"} - ${dayjs(endDate).isValid() ? dayjs(endDate).format("Do MMM, YYYY") : "---"
            }`;
        } else if (startDate && dayjs(startDate).isValid()) {
          return dayjs(startDate).format("Do MMM, YYYY");
        } else if (endDate && dayjs(endDate).isValid()) {
          return dayjs(endDate).format("Do MMM, YYYY");
        } else {
          return "---";
        }
      },
    },



    {
      title: "Status",
      dataIndex: "contractstatus",
      key: "contractstatus",
      width: "25%",
      render: (text, record) => {
        if (selectedItem === "performance-contract") {
          return text === "created" ||
            text === "resend" ||
            text === "updated" ? (
            "Waiting for Acceptance"
          ) : text === "accepted" ||
            text === "attended" ||
            text === "reviewed" ? (
            "Accepted"
          ) : text === "declined" ? (
            <p className="text-warning p-0 m-0">Declined</p>
          )
            :
            (
              <>
                <p className="text-danger p-0 m-0" style={{ display: "flex", alignItems: "center", }}>
                  Not Yet Created{text === "contractdraft" && <span style={{ background: "#ccc", borderRadius: "5px", color: 'grey' }} className="mx-2 px-2 py-1">Draft</span>}
                </p>

              </>
            );
        } else {
          const start = dayjs(record?.attendstartdate, "YYYY-MM-DD");
          const today = dayjs();
          if (text === "accepted" && today.isSameOrAfter(start)) {
            return "Awaiting Appraisee Response";
          } else if (text === "attended" || text === "draft") {
            return (
              <>
                <span style={{ color: "red" }}>Yet to Review </span>
                {text === "draft" && (
                  <span
                    style={{ background: "#ccc", borderRadius: "5px" }}
                    className="mx-2 px-2 py-1"
                  >
                    Draft
                  </span>
                )}
              </>
            );
          } else if (text === "reviewed") {
            return "Closed";
          }
        }
      },
    },

    {
      title: "Action",
      dataIndex: "contractstatus",
      key: "contractstatus",
      width: 300,
      align: "center",
      render: (text, record) => {
        const start = dayjs(record?.attendstartdate, "YYYY-MM-DD");
        const today = dayjs();

        const handleEditClick = (e) => {
          e.stopPropagation();
          setSelectedUserRecord(record);
          setIsAddEdit(true);
          setBreadCrum(true);
        };

        const handleCreateClick = (e) => {
          e.stopPropagation();
          setSelectedUserRecord(record);
          setIsAddEdit(true);
          setBreadCrum(false);
        };

        const handleDeleteClick = (e) => {
          e.stopPropagation();
          setRecordToDelete(record);
          setIsDeleteModalOpen(true);
        };

        const deleteIconWithModal = (
          <TrashDelete
            className="table_action_icon"
            onClick={handleDeleteClick}
          />
        );

        if (selectedItem === "performance-contract") {
          if (
            record.contractstatus === "accepted" ||
            record.contractstatus === "created" ||
            record.contractstatus === "declined" ||
            record.contractstatus === "attended" ||
            record.contractstatus === "reviewed" ||
            record.contractstatus === "resend" ||
            record.contractstatus === "updated"
          ) {
            return (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  justifyContent: "end",
                  margin: "0px -20px",
                }}
              >
                {
                  record.contractstatus !== "attended" &&
                  record.contractstatus !== "reviewed" && (
                    <>
                      <Editicon
                        name="edit"
                        className="table_action_icon"
                        onClick={handleEditClick}
                      />
                    </>
                  )}
                {record.contractstatus !== "accepted" && (
                  <>{deleteIconWithModal}</>
                )}
              </div>
            );
          }

          return (
            <ButtonFilled onClick={handleCreateClick}>
              Create Contract
            </ButtonFilled>
          );
        } else {
          if (text === "attended" || text === "draft") {
            return (
              <div className="d-flex align-items-center justify-content-end gap-2">
                <ButtonFilled
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push({
                      pathname: `/viewmytabledata/${record?.contractid}`,
                      state: {
                        appraisalRecord: record,
                        isEdit: text === "attended" || text === "draft",
                        data: record,
                        roletype: record.roletype,
                      },
                    });
                  }}
                >
                  Review
                </ButtonFilled>
              </div>
            );
          }

          if (text === "reviewed") {
            return (
              <div className="d-flex align-items-center justify-content-end gap-2">
                <ChartBarIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    getChartData(record?.userid, record?.performanceid);
                    setChartModalOpen(true);
                  }}
                  style={{
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                    borderRadius: "25px",
                    boxShadow:
                      "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
                  }}
                />
              </div>
            );
          }
        }
      },
    },
  ];

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const { Option } = Select;
  const handleFilter = (data) => {
    const type = data?.type || [];
    const performanceContractName = data?.name || [];
    const roleType = data?.roletype || [];
    const status = data?.status || [];
    const selectedDate = data?.date;

    const today = dayjs().endOf("day");
    let start = null;
    let end = null;

    // Handle date range logic
    if (selectedDate === "All") {
      setShowDateRange(false);
    } else if (selectedDate === "Last week") {
      start = dayjs().subtract(7, "days").startOf("day");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "Last month") {
      start = dayjs().subtract(1, "months").startOf("month");
      end = dayjs().subtract(1, "months").endOf("month");
      setShowDateRange(false);
    } else if (selectedDate === "Last 6 months") {
      start = dayjs().subtract(6, "months").startOf("month");
      end = today;
      setShowDateRange(false);
    } else if (selectedDate === "custom") {
      setShowDateRange(true);
      if (fromDate && toDate) {
        start = fromDate;
        end = toDate;
      } else {
        start = null;
        end = null;
      }
    } else if (selectedDate) {
      // If manually selected specific date
      const parsed = dayjs(selectedDate, "DD-MM-YYYY");
      start = parsed.startOf("day");
      end = parsed.endOf("day");
    }

    const sourceData =
      selectedItem === "performance-contract"
        ? findData
        : filterPerformanceData;

    return sourceData.filter((item) => {
      const typeMatch = type.length > 0 ? type.includes(item?.period) : true;
      const roleTypeMatch =
        roleType.length > 0
          ? roleType.includes(item?.appraisalInformation?.[0]?.roletype)
          : true;
      const statusMatch =
        status.length > 0 ? status.includes(item?.contractstatus) : true;
      const nameMatch =
        performanceContractName.length > 0
          ? performanceContractName.includes(item?.userid)
          : true;

      // Parse item attend dates

      // Apply actual filtering logic here
      const dateMatch =
        start && end
          ? dayjs(item?.attendstartdate)?.isSameOrBefore(end, "day") &&
          dayjs(item?.attendenddate)?.isSameOrAfter(start, "day")
          : true;
      return (
        typeMatch && roleTypeMatch && statusMatch && nameMatch && dateMatch
      );
    });
  };

  // Make sure this is called once in your file

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };

  const handleFormChange = () => {
    const values = form.getFieldsValue();
    setFilteredData(handleFilter(values));
  };
  useEffect(() => {
    handleFormChange();
  }, [selectedItem, findData, filterPerformanceData, fromDate, toDate]);

  const content = (
    <span>
      This will generate a new list of appraisees whose<br></br> previous
      appraisals have been closed, allowing<br></br> you to create fresh
      performance contracts for<br></br> them by retaining their previous
      contracts
    </span>
  );

  return (
    <Styleddiv>
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalOpen}
        onOk={() => deleteContract(recordToDelete)}
        onCancel={() => setIsDeleteModalOpen(false)}
        okText="Yes"
        cancelText="No"
        confirmLoading={isDeleteModalLoading} // ✅ loader on "Yes"
      >
        <p>Are you sure you want to delete this contract?</p>
      </Modal>

      {!isAddEdit && (
        <>
          <div>
            <Row>
              <Col sm={24}>
                <Form
                  form={form}
                  layout="vertical"
                  className="mt-2"
                  onValuesChange={handleFormChange}
                >
                  <Row gutter={12} className="g-3 mb-2">
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="name"
                        label="Search"
                        options={uniqBy(
                          (selectedItem === "performance-contract"
                            ? findData
                            : filteredData
                          ).map((val) => ({
                            label: val.fullname,
                            value: val.userid,
                          })),
                          "value"
                        )}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="type"
                        label="Period"
                        options={[
                          {
                            value: "Half Yearly Appraisal",
                            label: "Half Yearly",
                          },
                          { value: "Quarterly Appraisal", label: "Quarterly" },
                          { value: "Yearly Appraisal", label: "Yearly" },
                        ]}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <Form.Item
                        name="date"
                        label=""
                        className="search-type-date"
                      >
                        <Select
                          placeholder="Date"
                          value={selectedDateRange}
                          onChange={handleSelectChange}
                          className="custom-select"
                        >
                          <Option value="All">All</Option>
                          <Option value="Last week">Last Week</Option>
                          <Option value="Last month">Last Month</Option>
                          <Option value="Last 6 months">Last 6 Months</Option>
                          <Option value="custom">Custom</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    {showDateRange && (
                      <Form.Item>
                        <StyledRangePicker
                          format="DD-MM-YYYY"
                          onChange={(dates) => {
                            setFromDate(dates ? dates[0] : null);
                            setToDate(dates ? dates[1] : null);
                          }}
                        />
                      </Form.Item>
                    )}
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="roletype"
                        label="RoleType"
                        options={uniqBy(
                          (selectedItem === "performance-contract"
                            ? findData
                            : filterPerformanceData
                          )?.map((val) => {
                            return {
                              value: val?.appraisalInformation?.[0]?.roletype,
                              label: val?.appraisalInformation?.[0]?.roletype,
                            };
                          }),
                          "value"
                        )}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <DropdownCheckBox
                        name="status"
                        label="Status"
                        options={
                          selectedItem === "performance-contract"
                            ? uniqBy(
                              findData?.map((val) => {
                                return {
                                  value: val?.contractstatus,
                                  label:
                                    val?.contractstatus === "created" ||
                                      val?.contractstatus === "resend" ||
                                      val?.contractstatus === "updated"
                                      ? "Waiting for Acceptance"
                                      : val?.contractstatus === "accepted" ||
                                        val?.contractstatus === "attended"
                                        ? "Accepted"
                                        : val?.contractstatus === "declined"
                                          ? "Declined"
                                          : "Not Yet Created",
                                };
                              }),
                              "value"
                            )
                            : uniqBy(
                              filterPerformanceData?.map((val) => {
                                const start = dayjs(
                                  val?.attendstartdate,
                                  "YYYY-MM-DD"
                                );
                                const today = dayjs();
                                return {
                                  value: val?.contractstatus,
                                  label:
                                    val.contractstatus === "accepted" &&
                                      today.isSameOrAfter(start)
                                      ? "Awaiting Appraisee Response"
                                      : val?.contractstatus === "accepted" ||
                                        val?.contractstatus === "declined" ||
                                        val?.contractstatus === "attended"
                                        ? "Yet to Review"
                                        : val?.contractstatus === "reviewed"
                                          ? "Closed"
                                          : "Created",
                                };
                              }),
                              "value"
                            )
                        }
                        // options={[
                        //   {
                        //     value: "Half Yearly",
                        //     label: "Awaiting Appraisal Response",
                        //   },
                        //   { value: "Quarterly", label: "Yet to Review" },
                        //   { value: "Yearly", label: "Closed" },
                        // ]}
                        form={form}
                        handleFormChange={handleFormChange}
                      />
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            <br />
            <div className="w-100 d-flex justify-content-between align-items-center">
              <b>List of Contract: {filteredData?.length || 0}</b>
              {selectedItem === "performance-contract" && (
                <Popover placement="topLeft" content={content}>
                  <ButtonFilled
                    loading={newDataLoading}
                    onClick={getLoadNewList}
                  >
                    Load New List
                  </ButtonFilled>
                </Popover>
              )}
              {selectedItem === "performance-management" && (
                <ButtonFilled
                  // loading={newDataLoading}
                  onClick={() => setIsConsolidate(true)}
                >
                  Consolidated
                </ButtonFilled>
              )}
            </div>
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              rowClassName={() => "custom-row"}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
                onMouseEnter: () => setHoveredRow(record.contractid),
                onMouseLeave: () => setHoveredRow(null),
                style: { cursor: "pointer" },
              })}
            />
          </div>
        </>
      )}
      <Modal
        centered
        width={1000}
        style={{ borderRadius: "8px", overflow: "hidden" }}
        footer={null}
        title="Overall Performance Matrix"
        visible={chartModalOpen}
        onCancel={() => {
          setChartModalOpen(false);
          setChartData({});
        }}
      >
        <>
          <Spin spinning={chartLoading}>
            {chartData?.xvalue !== undefined &&
              chartData?.yvalue !== undefined ? (
              <PerformanceMatrix
                Xaxis={chartData?.xvalue}
                Yaxis={chartData?.yvalue}
              />
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 300,
                  }}
                >
                  <FolderIcon
                    style={{ width: 200, height: 200, marginBottom: 10 }}
                  />{" "}
                  <p
                    style={{ fontSize: 18, color: "#999", textAlign: "center" }}
                  >
                    {" "}
                    The Appraiser(s) haven't Reviewed the appraisal yet
                  </p>
                </div>
              </>
            )}
          </Spin>
        </>
      </Modal>
      <Modal
        centered
        width={1000}
        style={{ borderRadius: "8px", overflow: "auto" }}
        footer={null}
        title="Consolidated Performance Matrix of Primary Appraisees"
        visible={isConsolidate}
        onCancel={() => {
          setIsConsolidate(false);
        }}
      >
        <Consolidated
          contractData={filterPerformanceData?.filter(
            (val) =>
              (val?.contractstatus === "reviewed" ||
                val?.contractstatus === "draft") &&
              val?.appraisalInformation[0]?.roletype === "Primary"
          )}
        />
      </Modal>
    </Styleddiv>
  );
};
const mapStateToProps = (state) => ({
  supervisorList: getSupervisorList(state),
  userInfo: getUserInfo(state),
  loadNewDataList: getLoadNewDataList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLoadNewData: setLoadNewDataList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(MyTeamPerformance);
